
import "../styles/AddTribute.css"
import { FaEdit } from "react-icons/fa"
import { BsFillTrash2Fill } from "react-icons/bs"
import { useEffect, useState } from "react"


const ConnectFamilyTree = () => {
    const [images, setImages] = useState([])
    const [imagesUrl, setImagesUrl] = useState([])
    const [loading, setLoading] = useState(false)
    const [imageLength, setImageLength] = useState(0)
    const [imagefile, setImageFile] = useState();

    useEffect(() => {

    }, [imagesUrl])

    const handleDeleteImage = (index) => {
        setImagesUrl((prevImages) => {
            const updatedImagesUrl = [...prevImages];
            updatedImagesUrl.splice(index, 1);
            return updatedImagesUrl;
        });
        
        // Remove the image from images (the actual file objects)
        setImages((prevImages) => {
            const updatedImages = [...prevImages];
            updatedImages.splice(index, 1);
            return updatedImages;
        });
        console.log(images)
        console.log(imagesUrl)
    }
    const handleImageUpload = (e) => {
        
        images.push(imagefile)
        setImageLength(imageLength + 1)
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0];
    
        if (file) {
    
          const reader = new FileReader();
          console.log(reader)
    
          reader.onloadend = () => {
            setImagesUrl(prevImages => [...prevImages, reader.result]);
        };
        
        reader.readAsDataURL(file);
    }
        setImages(prevImages => [...prevImages, file]);
        console.log(imagesUrl)

      };

    return<>

    <div className="addTribute">
      <div className="addTributeHeading">
        <h2>Connect to the family tree</h2>
        <p>Fill the form to connect to the family tree.</p>
      </div>

        <form action="">
            <div className="inputWrapper">
                <label htmlFor="">Name</label>
                <small>Enter your name as it may appear on the tree</small>
                <input type="text" placeholder="Enter your full name"/>
            </div>
            <div className="inputContainer">
                <div className="inputWrapper">
                    <label htmlFor="">Relationship</label>
                    <small>What is your relationship with the deceased?</small>
                    <input type="text" placeholder="Enter your relationship"/>
                </div>
                <div className="inputWrapper">
                    <label htmlFor="">Position</label>
                    <small>What position are you in your family</small>
                    <input type="text" placeholder="First, Second, Third, Last,..."/>
                </div>
            </div>
            <div className="inputContainer">
                <div className="inputWrapper">
                    <label htmlFor="">Birthday</label>
                    <small>What date were you born?</small>
                    <input type="datetime-local" placeholder="Select date"/>
                </div>
                <div className="inputWrapper">
                    <label htmlFor="">Phone Number</label>
                    <small>Enter your phone number</small>
                    <input type="text" placeholder="Enter Phone No."/>
                </div>
            </div>
            <div className="inputWrapper">
                <label htmlFor="">Profile Picture</label>
                <small>Upload a profile photo as it will appear on the tree.</small>
                <input type="file" placeholder="Enter your relationship"/>
            </div>
            <div className="inputWrapper">
                <label htmlFor="">Images</label>
                <small>Upload other images that will be attached to your tree details profile</small>
                <input type="file" placeholder="Enter your relationship" onChange={(e) => handleImageChange(e)}/>
            </div>
            <div className="imagesPreview">
                {
                    imagesUrl.map((el, index) => {
                        return<>
                        <div key={index} className="imageHolder">
                            <img src={el} alt="" />
                        <BsFillTrash2Fill className="tributeDelete" onClick={() => handleDeleteImage(index)}/>
                        </div>
                        </>
                    })
                }
            </div>

            <div className="addTributeButton">
                <button>Connect</button>
            </div>
        </form>
    </div>
        

    </>

}

export default ConnectFamilyTree